import { RootState } from "@src/reducers/store";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export const usePillNavigationHook = (
  options,
  activeView,
  onChangeCallback,
) => {
  const structureWasSaved = useSelector(
    (state: RootState) => state.yourSlice.structureWasSaved,
  );

  const nodeManager = getNodeManager();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [backgroundStyle, setBackgroundStyle] = useState({ width: 0, left: 0 });
  const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isFirstRender, setIsFirstRender] = useState(true);
  useLayoutEffect(() => {
    if (buttonRefs.current[selectedIndex]) {
      const selectedButton = buttonRefs.current[selectedIndex];
      if (selectedButton) {
        setBackgroundStyle({
          width: selectedButton.offsetWidth,
          left: selectedButton.offsetLeft,
        });
      }
    }
  }, [selectedIndex, options, isFirstRender]);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    }
  }, [isFirstRender]);

  useEffect(() => {
    const linkIndex = options.map((option) => option.link).indexOf(activeView);
    if (linkIndex !== -1) {
      setSelectedIndex(linkIndex);
    }
  }, [activeView]);

  const handleClick = (index: number, option: string) => {
    onChangeCallback(option);
    // this blocks navigation and selection of
    // destination pill if the structure or condition monitoring was not saved
    if (!structureWasSaved) return;
    if (!nodeManager.isAlarmProfilesReferenceCopyEqualToAlarmProfiles()) return;
    setSelectedIndex(index);
  };

  const firstRenderTransition = () =>
    isFirstRender ? "none" : "left 0.3s ease, width 0.3s ease";

  return {
    containerRef,
    backgroundStyle,
    buttonRefs,
    selectedIndex,
    firstRenderTransition,
    handleClick,
  };
};
